import { render, staticRenderFns } from "./Wheel.vue?vue&type=template&id=0407a5fc&scoped=true&"
import script from "./Wheel.vue?vue&type=script&lang=js&"
export * from "./Wheel.vue?vue&type=script&lang=js&"
import style0 from "./Wheel.vue?vue&type=style&index=0&id=0407a5fc&lang=scss&scoped=true&"
import style1 from "./Wheel.vue?vue&type=style&index=1&id=0407a5fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0407a5fc",
  null
  
)

export default component.exports